export default __webpack_public_path__ + "static/media/542035__rob-marion__gasp-ui-notification-4.9f95e69a.wav";